import { useEffect, useState } from 'react';
import { isClientSide } from 'src/utils/constants';

export const usePortalContainer = (modalContainerId = 'modal-root') => {
  const defaultContainer =
    isClientSide && document
      ? document.querySelector(`#${modalContainerId}`)
      : null;

  const [container, setContainer] = useState(defaultContainer);

  useEffect(
    () => {
      const newContainer =
        isClientSide && document
          ? document.querySelector(`#${modalContainerId}`)
          : null;
      if (defaultContainer !== newContainer) {
        setContainer(newContainer);
      }
    },
    // TODO: it's unclear what this constructions does. Requires investigate and simpilifaction to primitives. Or using useDeepCompareEffect
    [isClientSide ?? document]
  );

  return container;
};
